import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

import CheckIcon from "assets/dialog_assets/circleCheck.svg";

export default function MatchingDetailDialog({
  open,
  onClose,
  onConfirm,
  data,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: 3,
          width: "100%",
          maxWidth: "360px",
        },
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "24px",
          backgroundColor: "#ffffff",
          textAlign: "center",
          gap: "18px",
        }}
      >
        <div className="f20_111827_W600">이름 : {data?.name}</div>
        <div className="f14_4B5563_W400">전화번호 : {data?.phoneNumber}</div>
        <div className="f14_4B5563_W400">주소 : {data?.address}</div>
        <div
          onClick={() => (onConfirm ? onConfirm() : onClose())}
          className="f16_FFFFFF_W500"
          style={{
            margin: "auto",
            flex: "1",
            padding: "13px 82px",
            backgroundColor: "#2E4A24",
            borderRadius: "8px",
            cursor: "pointer",
          }}
        >
          확인
        </div>
      </div>
    </Dialog>
  );
}
